// // Use $ instead of jQuery without replacing global $
(function ($) {
  // On DOM ready
  $(document).ready(function () {

    var $col_image_tab = $('body .col-image-tab .tab-box .tab-content .tab-pane .bg-img img');
    objectFitImages($col_image_tab);

    $('.col-image-tab .tab-box .tab-panel-outer > ol > li').first().addClass( "active" );
    $('.col-image-tab .tab-box .tab-panel-outer > ol > li ').click(function () {
      $(this).parents('ol').find('li').removeClass('active');
      $(this).parents('ol').find('p').removeAttr('style');
      $(this).find('p').fadeIn();
      $(this).addClass('active');
    });
  });

})(jQuery);